/*---------------------------------------------------------*\
 * Imports
 \*---------------------------------------------------------*/
import _ from 'lodash';
import PubSub from 'pubsub-js';
import angular from 'angular';

const deps = {};

/*---------------------------------------------------------*\
 * Weakmaps
 \*---------------------------------------------------------*/
const TIMEOUT = new WeakMap();
const TOPICS = new WeakMap();
const NAVIGATION = new WeakMap();

/*---------------------------------------------------------*\
 * WeatherHomeLanding
 \*---------------------------------------------------------*/
function gotoVideo(story) {
  deps.$state.go(deps.states.videoplayer, { category: 'weather', currentStory: story }, { location: true });
}

class WeatherHomeLandingController {
  //-----------------------------------
  // Constructor
  //-----------------------------------
  constructor($q, $state, $stateParams, $scope, $timeout, topics, navigationService, photos, weatherVideoService,
              weatherCurrentService, localService, storageKeys, states, tickerService, adProps, $rootScope) {
    TIMEOUT.set(this, $timeout);
    TOPICS.set(this, topics);
    NAVIGATION.set(this, navigationService);

    deps.$state = $state;
    deps.$rootScope = $rootScope;
    this.adProps = adProps;
    deps.tickerService = tickerService;
    deps.$stateParams = $stateParams;
    this.name = 'weatherHomeLanding';
    deps.states = states;
    this.$scope = $scope;
    this.photos = photos;

    deps.weatherVideoService = weatherVideoService;
    deps.localService = localService;
    // this.currentRegion is the LOCAL region variable
    this.currentRegion = deps.$stateParams.subRegion ? JSON.parse(deps.$stateParams.subRegion) :
        localService.get(storageKeys.selectedRegion);
    // const region is the GLOBAL region variable
    const region = _.isUndefined(this.subRegion) ? deps.localService.get(storageKeys.selectedRegion) : this.subRegion;
    $q.all([
      this.loadWeatherVideo(this.currentRegion),
      this.loadTicker(this.currentRegion)
    ]).then((values) => {
      const menu = values[0];
      const link = menu.rss.channel.item['media:content'].url;
      this.currentStory = {
        story: { videoUrl: link }
      };
      if (this.tickerData.type === 'WEATHER ALERT') {
        this.showWeatherAlertButton = true;
        this.showWeatherAlert = true;
        this.setAlertBadge(this.leftNavItems, this.tickerData);
      }
    });

    this.showWeatherAlertButton = false;
    this.showWeatherAlert = false;
    this.showSubMenu = false;
    this.showMenu = true;
    this.leftNavItems = [
      {
        id: 'news',
        title: 'News',
        state: deps.states.home,
        sections: []
      },
      {
        id: 'traffic',
        title: 'Traffic',
        state: deps.states.traffic_center,
        sections: []
      }
    ];
    this.subnavMenuItems = [
      {
        title: 'Current',
        id: 'Current'
      }
    ];
    const token = PubSub.subscribe(TOPICS.get(this).nav.enter, (msg, data) => {
      if (data.source === 'navbar') {
        this.showWeatherAlert = false;
        // When clicking on subnav
        for (const i in this.subnavMenuItems) {
          if ({}.hasOwnProperty.call(this.subnavMenuItems, i)) {
            if (data.data === this.subnavMenuItems[this.subnavMenuItems.length - 1]) {
              this.subNavSelect(this.subnavMenuItems[this.subnavMenuItems.length - 1]);
            } else if (data.data === this.subnavMenuItems[i]) {
              if (!_.isUndefined(this.subRegion)) {
                weatherCurrentService.getWeatherSubMenu(region.abbr).then(this.applySubMenu.bind(this));
              } else {
                weatherCurrentService.getWeatherSubMenu(this.currentRegion.abbr).then(this.applySubMenu.bind(this));
              }
            } else {
              this.subNavSelect(data.data);
            }
          }
        }
        // when clicking on subnavSecondary
        for (const i in this.subnavSecondaryMenuItems) {
          if ({}.hasOwnProperty.call(this.subnavMenuItems, i)) {
            this.showWeatherAlert = false;
            if (data.data === this.subnavSecondaryMenuItems[i]) {
              // When clicking on back on subnavsecondary
              if (data.data === this.subnavSecondaryMenuItems[0]) {
                this.showSubMenu = false;
                this.showMenu = true;
                data.data = this.subnavMenuItems[0];
                //  When clicking on forecast video
              } else if (data.data.title === 'Forecast Video') {
                gotoVideo(this.currentStory);
              } else {
                this.subNavSelect(this.subnavSecondaryMenuItems[i]);
                const currentlink = this.subnavSecondaryMenuItems[i].link;
                if (data.data.title === this.subnavSecondaryMenuItems[i].id) {
                  this.selectImage(currentlink);
                  break;
                }
              }
            } else {
              this.subNavSelect(data.data);
            }
          }
        }
        this.$scope.$apply();
      }
    });

    const token1 = PubSub.subscribe(topics.state.reactivate, () => {
      if (deps.$rootScope.previousActiveElement) {
        // Restore focus to previously focused dom element
        $timeout(() => {
          if (this.isFocusLost(deps.$rootScope.previousActiveElement)) {
            NAVIGATION.get(this).focusElAsync('.main-content');
          } else {
            this.subNavSelect(this.subnavMenuItems[1]);
            this.selectedIndex = 1;
          }
          delete deps.$rootScope.previousActiveElement;
        });
      }
    });

    this.$scope.$on('$destroy', () => {
      PubSub.unsubscribe(token);
      PubSub.unsubscribe(token1);
    });

    weatherCurrentService.getWeatherSubMenu(this.currentRegion.abbr).then(this.applyMenu.bind(this));
    this.$onInit = () => {
      this.selectedIndex = 0;
    };
    this.subNavSelect(this.subnavMenuItems[0]);
  }

  //-----------------------------------
  // Methods
  //-----------------------------------
  subNavSelect(item) {
    this.activeSection = item;
    // This initial timeout is necessary to wait for the old .main-content to have
    // been cleared from the DOM
    TIMEOUT.get(this)(() => {
      if (this.showMenu) {
        // focus on navbar
        NAVIGATION.get(this).focusElAsync('.selected');
      } else {
        // focus on subnavbar
        NAVIGATION.get(this).focusElAsync('navbar.test .selected');
      }
    });
  }

  isFocusLost(prevHtmlElement) {
    // if for any reason focus is lost and lands on the body or a subNavItem element was the last item focused
    // before changing state then set focus to the main content section. Mostly used for T&W and forecast video
    // https://tools.emedia.cv.net/jira/browse/NSW-424
    // but can be used for other use cases
    if (angular.isDefined(prevHtmlElement) && (_.contains(prevHtmlElement.tagName.toLowerCase(), 'body') ||
        _.contains(prevHtmlElement.className, 'sub-nav-item'))) {
      NAVIGATION.get(this).focusElAsync('.main-content');
    }
  }

  loadTicker(region) {
    const regions = region ? region.abbr : 'LI';
    return deps.tickerService.getTicker(regions)
        .then((res) => {
          this.tickerData = {
            type: res.data.rss.channel.item.title,
            message: res.data.rss.channel.item.content
          };
          return res.data;
        });
  }

  loadWeatherVideo(region) {
    const regions = region ? region.abbr : 'LI';
    return deps.weatherVideoService.getweatherVideo(regions)
        .then((res) => {
          return res.data;
        });
  }

  setAlertBadge(menu, type) {
    const el = document.getElementById('weather_alert_message');
    const types = {
      'WEATHER ALERT': 'weather',
      'TRAFFIC ALERT': 'traffic'
    };
    const id = types[type.type];
    if (id) {
      menu.forEach((item) => {
        item.badge = item.id === id ? 'Alert' : null;
      });
    }
    el.innerHTML = 'loading...';
    el.innerHTML = type.message;
  }

  isActiveSection(section) {
    return section === this.activeSection.id;
  }

  navSelect(item) {
    if (item && item.state) {
      deps.$state.go(item.state);
    }
  }

  onRegionSelect(region) {
    deps.$state.go(deps.$state.$current, { subRegion: JSON.stringify(region) });
    this.selectedIndex = 0;
    this.subNavSelect(this.subnavMenuItems[0]);
  }

  weatherAlert_onSelect() {
    this.showWeatherAlert = true;
  }

  selectImage(item) {
    // Create temporary image attribute so we can load the image and display
    // loading while it is coming in.
    const img = document.createElement('img');

    this.loading = true;
    this.error = false;

    img.addEventListener('load', () => {
      this.loading = false;
      this.$scope.$apply();
    });

    img.addEventListener('error', () => {
      this.error = true;
      this.loading = false;
      this.$scope.$apply();
    });

    img.src = item;
    this.activeSection.link = img.src;
  }

  applyMenu(item) {
    const groups = _.groupBy(item.data.location.menu, subgroup => subgroup.menuName);
    const subnavMenuArray = [];

    for (const key in groups) {
      if ({}.hasOwnProperty.call(groups, key)) {
        const CurrentLink = _.isEmpty(groups[key][0].display) ?
          groups[key][0].submenu.item[0].itemDisplay :
          groups[key][0].display;

        subnavMenuArray.push({
          title: key,
          id: key,
          link: CurrentLink
        });
      }
    }

    TIMEOUT.get(this)(() => {
      this.subnavMenuItems = subnavMenuArray;
      this.subnavMenuItems.splice(this.subnavMenuItems.length, 0, { title: 'Region', id: 'Region' });
      // focus on index 0 in subnavbar
      this.selectedIndex = 0;
    });
    this.selectImage(subnavMenuArray[0].link);
    this.subNavSelect(subnavMenuArray[0]);
  }

  applySubMenu(item) {
    const subnavSecondaryMenuArray = [];

    const groups = _.groupBy(item.data.location.menu, subgroup => subgroup.menuName);
    for (const key in groups) {
      if ({}.hasOwnProperty.call(groups, key)) {
        if (key === this.activeSection.id && _.isEmpty(groups[key][0].display)) {
          const subMenuArray = groups[key][0].submenu.item;
          for (const j in subMenuArray) {
            if ({}.hasOwnProperty.call(subMenuArray, j)) {
              subnavSecondaryMenuArray.push({
                title: subMenuArray[j].itemName,
                id: subMenuArray[j].itemName,
                link: subMenuArray[j].itemDisplay
              });
            }
          }
          this.showSubMenu = true;
          this.showMenu = false;
          // focus on index 1 subnavbarSecondary
          this.selectedIndex = 1;
          break;
        } else {
          this.showSubMenu = false;
          this.showMenu = true;
        }
      }
    }
    TIMEOUT.get(this)(() => {
      this.subnavSecondaryMenuItems = subnavSecondaryMenuArray;
      this.subnavSecondaryMenuItems.splice(0, 0, { title: 'Back', id: 'Back' });
      this.subnavSecondaryMenuItems.splice(this.subnavSecondaryMenuItems.length, 0, { title: 'Region', id: 'Region' });
    });
    this.selectImage(subnavSecondaryMenuArray[0].link);
  }
}

WeatherHomeLandingController.$inject = [
  '$q',
  '$state',
  '$stateParams',
  '$scope',
  '$timeout',
  'topics',
  'navigationService',
  'photos',
  'weatherVideoService',
  'weatherCurrentService',
  'localService',
  'storageKeys',
  'states',
  'tickerService',
  'adProps',
  '$rootScope'
];

export default WeatherHomeLandingController;



/** WEBPACK FOOTER **
 ** ./client/app/components/weatherHomeLanding/weatherHomeLanding.controller.js
 **/